import { useEffect, useState } from "react";
import "../assets/css/Home.css";
import { FaCheck } from "react-icons/fa";
import {
  TbSettingsAutomation,
  TbCpu,
  TbCode,
  TbChartInfographic,
  TbCertificate,
  TbBriefcase,
  TbPresentation,
  TbBuilding,
  TbChecklist,
  TbDeviceLaptop,
} from "react-icons/tb";
import Marquee from "react-fast-marquee";
import banner2 from "../assets/img/Home/banner-2.jpg";
import banner1 from "../assets/img/Home/banner-1.jpg";
import serv1 from "../assets/img/Home/serv-1.png";
import serv2 from "../assets/img/Home/serv-2.png";
import serv3 from "../assets/img/Home/serv-3.png";
import serv4 from "../assets/img/Home/serv-4.png";
import { Helmet } from "react-helmet";
import data from "./ApiUrl/meta_api";

// AOS
import AOS from "aos";
import "aos/dist/aos.css";

// Slider
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
const PRIMARY = "#cc0000";

// ── Data
const slider_1 = [
  { num: "200+", label: "Happy Clients" },
  { num: "2500+", label: "Students Trained" },
  { num: "5+", label: "Years Experience" },
  { num: "95%", label: "Placement Rate" },
  { num: "4.8⭐", label: "Student Rating" },
];

const slider_2 = [
  { num: "5+", label: "Years Experience" },
  { num: "200+", label: "Clients Served" },
  { num: "2500+", label: "Students Trained" },
  { label: "Pan-India Presence" },
];

const tickerItems = [
  "● Industrial Automation",
  "● Embedded Systems & IIoT",
  "● IT & Software Development",
  "● Digital Marketing",
  "● Certification Courses",
  "● Corporate Training",
  "● Internships & Projects",
];

const problems = [
  {
    icon: "🏭",
    title: "For Businesses & Industries",
    color: PRIMARY,
    items: [
      "Struggling with production downtime",
      "Need smart automation & IIoT integration?",
      "Looking to build a digital presence & online?",
      "Want custom software & solutions?",
    ],
  },
  {
    icon: "🎓",
    title: "For Students & Professionals",
    color: "#1d9e75",
    items: [
      "Struggling to find a job after graduation?",
      "Want to upskill and get promoted faster?",
      "Looking for real industry experience?",
      "Need placement support & guidance?",
    ],
  },
];

const services = [
  {
    icon: <TbSettingsAutomation />,
    bg: "#fcebeb",
    iconColor: "#a32d2d",
    name: "Industrial Automation",
    sub: "Smart manufacturing solutions",
    desc: "PLC, SCADA, robotics, panel fabrication & energy management reducing downtime and boosting productivity.",
    tags: ["PLC", "SCADA", "Robotics", "HMI", "VFD"],
  },
  {
    icon: <TbCpu />,
    bg: "#e6f1fb",
    iconColor: "#0c447c",
    name: "Embedded Systems & IIoT",
    sub: "Connected industry solutions",
    desc: "Firmware, PCB design, IIoT integration & smart monitoring connecting your machines to the future.",
    tags: ["IIoT", "Embedded", "PCB Design", "Firmware"],
  },
  {
    icon: <TbCode />,
    bg: "#eeedfe",
    iconColor: "#3c3489",
    name: "IT & Software Development",
    sub: "Digital transformation partner",
    desc: "Web & mobile apps, AI/ML, cloud, cybersecurity & custom enterprise software for modern businesses.",
    tags: ["AI/ML", "Cloud", "Web Apps", "Mobile Apps"],
  },
  {
    icon: <TbChartInfographic />,
    bg: "#e1f5ee",
    iconColor: "#085041",
    name: "Digital Marketing",
    sub: "Grow your brand online",
    desc: "SEO, social media, paid ads, branding & analytics building your digital presence and driving real revenue.",
    tags: ["SEO", "Ads", "Branding", "Social Media"],
  },
];

const trainings = [
  {
    icon: <TbCertificate />,
    bg: "#faeeda",
    iconColor: "#633806",
    name: "Certification Courses",
    sub: "Industry-recognized programs",
    desc: "Automation, IT, AI, data science & digital marketing certifications built for real job requirements.",
    tags: [
      "Certified",
      "Job-Ready",
      "Skill Training",
      "Industry Certification",
    ],
  },
  {
    icon: <TbBriefcase />,
    bg: "#eaf3de",
    iconColor: "#27500a",
    name: "Internship Programs",
    sub: "Real industry experience",
    desc: "1–6 month internships working on live projects under expert mentorship with certificate & placement support.",
    tags: ["Live Projects", "Certificate", "Internship", "Placement Support"],
  },
  {
    icon: <TbPresentation />,
    bg: "#fcebeb",
    iconColor: "#a32d2d",
    name: "Seminars & Workshops",
    sub: "Expert-led skill sessions",
    desc: "1–3 day intensive workshops on emerging technologies open for colleges, companies & individuals.",
    tags: ["1-3 Days", "Expert-Led", "Short Term", "Expert-Led Training"],
  },
  {
    icon: <TbBuilding />,
    bg: "#e6f1fb",
    iconColor: "#0c447c",
    name: "Corporate Training",
    sub: "Upskill your entire team",
    desc: "Customized on-site or online training programs for corporates with progress reports and certification.",
    tags: ["On-Site", "Customized", "Corporate", "Employee Training"],
  },
  {
    icon: <TbChecklist />,
    bg: "#e6f1fb",
    iconColor: "#0c7c12",
    name: "Live Project Work",
    sub: "Hands-on Industry Experience",
    desc: "Gain real-world experience by working on live industrial projects with expert guidance.",
    tags: ["Real Projects", "Mentorship", "Hands-on", "Industry Training"],
  },
  {
    icon: <TbDeviceLaptop />,
    bg: "#e6f1fb",
    iconColor: "#0c447c",
    name: "Online & Classroom",
    sub: "Flexible Learning Options",
    desc: "Learn through interactive online sessions or classroom training with practical industry focused learning.",
    tags: ["Online Training", "Classroom", "Hybrid", "Flexible Learning"],
  },
];

const results = [
  {
    image: require("../assets/img/Home/impact-1.png"),
    num: "200+",
    label: "Businesses Served Across India",
  },
  {
    image: require("../assets/img/Home/impact-2.png"),
    num: "2500+",
    label: "Students Successfully Trained",
  },
  {
    image: require("../assets/img/Home/impact-3.png"),
    num: "95%",
    label: "Student Placement Rate",
  },
  {
    image: require("../assets/img/Home/impact-4.png"),
    num: "40%",
    label: "Avg. Downtime Reduction for Clients",
  },
  {
    image: require("../assets/img/Home/impact-5.png"),
    num: "200+",
    label: "Corporate Training Batches",
  },
  {
    image: require("../assets/img/Home/impact-6.png"),
    num: "100+",
    label: "Industry Projects Delivered",
  },
  {
    image: require("../assets/img/Home/impact-7.png"),
    num: "5+",
    label: "Years of Industry Excellence",
  },
  {
    image: require("../assets/img/Home/impact-8.png"),
    num: "4.8⭐",
    label: "Average Student & Client Rating",
  },
];

const audiences = [
  {
    icon: serv1,
    bg: "#fcebeb",
    tc: "#a32d2d",
    title: "Industries & Businesses",
    desc: "Manufacturing, oil & gas, pharma, food & beverage, renewable energy we serve 20+ industries with smart automation and technology solutions.",
    tags: [
      "Automation",
      "IT Solutions",
      "Digital Marketing",
      "Smart Solutions",
    ],
  },
  {
    icon: serv2,
    bg: "#e6f1fb",
    tc: "#0c447c",
    title: "Students & Freshers",
    desc: "Build job-ready skills with certification courses, internships & live projects and get placed in top companies with our dedicated placement support.",
    tags: ["Certifications", "Internships", "Placement", "Job Ready Training"],
  },
  {
    icon: serv3,
    bg: "#e1f5ee",
    tc: "#085041",
    title: "Working Professionals",
    desc: "Upskill, reskill or pivot your career with advanced weekend courses and workshops designed around your busy professional schedule.",
    tags: ["Upskilling", "Weekend Batches", "Advanced", "Career Growth"],
  },
  {
    icon: serv4,
    bg: "#faeeda",
    tc: "#633806",
    title: "Corporates & HR Teams",
    desc: "Empower your workforce with customized on-site or online corporate training with assessments, progress reports and certification for every employee.",
    tags: ["Corporate", "On-Site", "Customized", "Employee Training"],
  },
];

const industries = [
  "🏗️ Manufacturing",
  "🛢️ Oil & Gas",
  "☀️ Renewable Energy",
  "💊 Pharmaceuticals",
  "🍔 Food & Beverage",
  "🚗 Automotive",
  "🏥 Healthcare",
  "🏗️ Infrastructure",
  "💧 Water Treatment",
  "📦 Logistics",
  "🎓 Education",
  "💻 Information Technology",
];

const partners = [
  {
    image: require("../assets/img/Logo/logo-1.jpg"),
    name: "Mitsubishi",
    type: "Automation",
  },
  {
    image: require("../assets/img/Logo/logo-2.jpg"),
    name: "Siemens",
    type: "Automation",
  },
  {
    image: require("../assets/img/Logo/logo-3.jpg"),
    name: "Delta",
    type: "Drives & PLC",
  },
  {
    image: require("../assets/img/Logo/logo-4.jpg"),
    name: "Omron",
    type: "Automation",
  },
  {
    image: require("../assets/img/Logo/logo-5.jpg"),
    name: "Rockwell",
    type: "Industrial",
  },
  {
    image: require("../assets/img/Logo/logo-6.jpg"),
    name: "ABB",
    type: "Robotics",
  },
];

const testimonials = [
  {
    avatar: require("../assets/img/Home/team-1.jpg"),
    quote:
      "Skimitar's automation solutions reduced our production downtime by 40%. Our efficiency improved dramatically within just 3 months of implementation.",
    author: "Operations Manager",
    role: "Manufacturing Company, Tamil Nadu",
    badge: "Industry Client",
    bg: "#fcebeb",
    tc: "#a32d2d",
  },
  {
    avatar: require("../assets/img/Home/team-2.jpg"),
    quote:
      "The PLC & SCADA course was incredibly practical. I secured a job within 2 months of completing the program. The mentors are genuinely industry experts.",
    author: "Karthik R.",
    role: "B.E. Graduate, Placed at MNC",
    badge: "Student",
    bg: "#e6f1fb",
    tc: "#0c447c",
  },
  {
    avatar: require("../assets/img/Home/team-3.jpg"),
    quote:
      "We enrolled 30 engineers in Skimitar's corporate training. The content was perfectly aligned with our operational needs. Highly recommend to any manufacturing company.",
    author: "HR Manager",
    role: "Process Industry, Chennai",
    badge: "Corporate Client",
    bg: "#faeeda",
    tc: "#633806",
  },
  {
    avatar: require("../assets/img/Home/service_3.jpg"),
    quote:
      "The internship gave me real project experience that no classroom could provide. Skimitar truly bridges the gap between education and industry.",
    author: "B.E. Student",
    role: "Anna University, Tamil Nadu",
    badge: "Intern",
    bg: "#faeeda",
    tc: "#0017e4",
  },
];

const leadPoints = [
  {
    icon: "⚡",
    title: "Fast Response Guaranteed",
    desc: "Our team responds to all enquiries within 24 business hours.",
  },
  {
    icon: "💰",
    title: "Transparent & Competitive Pricing",
    desc: "Clear, honest pricing with no hidden charges. Ever.",
  },
  {
    icon: "🌍",
    title: "Pan-India Service & Training",
    desc: "Online and on-site service available across all major states.",
  },
  {
    icon: "🎯",
    title: "Customized Solutions",
    desc: "No one-size-fits-all. Every solution is tailored to your needs.",
  },
];

// Slider
const testimonial_slider = {
  dots: true,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 600,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

// ── Sub-Components
function SectionLabel({ text }) {
  return (
    <p
      className="fw-semibold text-uppercase mb-1"
      style={{ fontSize: 20, color: PRIMARY, letterSpacing: 1 }}
    >
      {text}
    </p>
  );
}

function ServiceCard({ item }) {
  return (
    <div className="card h-100 shadow" style={{ borderColor: "#e5e5e5" }}>
      <div className="card-body d-flex flex-column gap-2">
        <div className="d-flex align-items-start gap-2">
          <div
            className="rounded-3 d-flex align-items-center justify-content-center flex-shrink-0"
            style={{ width: 40, height: 40, background: item.bg, fontSize: 18 }}
          >
            {item.icon}
          </div>
          <div>
            <p className="fw-semibold mb-0" style={{ fontSize: 13 }}>
              {item.name}
            </p>
            <p className="mb-0 text-muted" style={{ fontSize: 12 }}>
              {item.sub}
            </p>
          </div>
        </div>
        <p className="mb-2" style={{ fontSize: 14, lineHeight: 1.6 }}>
          {item.desc}
        </p>
        <div className="d-flex flex-wrap gap-1 mt-auto">
          {item.tags.map((t) => (
            <span
              key={t}
              className="badge rounded-pill"
              style={{
                background: item.bg,
                color: item.iconColor,
                fontSize: 11,
              }}
            >
              {t}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

// ── Main Component

export default function Home() {
  const [meta, setMeta] = useState(null);
  const [activeTab, setActiveTab] = useState("svc");
  const [form, setForm] = useState({ name: "", phone: "", need: "" });
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  // scroll top
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const fetchData = () => {
    const HomeMeta = data[0]?.home_page;
    if (HomeMeta) {
      setMeta(HomeMeta);
    }
  };

  useEffect(() => {
    fetchData();

    // AOS initialization
    AOS.init({
      duration: 700,
      easing: "ease-in-out",
      once: true,
      mirror: false,
      // Disable animations on very small screens to avoid layout glitches
      disable: false,
    });
  }, []);

  // Refresh AOS when tab changes so newly rendered cards animate in
  useEffect(() => {
    AOS.refresh();
  }, [activeTab]);

  const handleSubmit = () => {
    if (form.name && form.phone) setSubmitted(true);

    alert("Data Submitted Successfully");
  };

  return (
    <>
      <Helmet>
        <title>{meta ? meta.title : "Home"}</title>
      </Helmet>

      {/* ── Carousel */}
      <div
        id="carouselExampleFade"
        className="carousel slide carousel-fade"
        data-bs-ride="carousel"
        data-bs-interval="5000"
      >
        <div className="carousel-inner">
          {/* Slide 1 */}
          <div
            className="carousel-item active"
            style={{
              backgroundImage: `url(${banner2})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              minHeight: "88vh",
            }}
          >
            <div className="d-flex flex-column justify-content-center align-items-center text-center p-4 p-md-5 h-100">
              <span
                className="hero-badge fw-semibold d-inline-block mb-3 py-2"
                data-aos="fade-down"
                data-aos-delay="100"
              >
                🏆 Trusted by 200+ Clients & 2500+ Students
              </span>

              <h1
                className="fw-semibold fs-1 text-white mb-3 hero_zindex"
                style={{ fontSize: "clamp(20px,4vw,28px)", lineHeight: 1.4 }}
                data-aos="fade-down"
                data-aos-delay="250"
              >
                India's Premier Destination for
                <br />
                <span style={{ color: PRIMARY }}>
                  Industrial Solutions & Career Training
                </span>
              </h1>

              <p
                className="hero-text mx-auto mb-4"
                style={{ fontSize: 15, maxWidth: 700, lineHeight: 1.8 }}
                data-aos="fade-down"
                data-aos-delay="400"
              >
                From automating factories to launching careers — Skimitar
                Hindusthan delivers cutting-edge technology services and
                industry-aligned training programs that create real, measurable
                results.
              </p>

              <div
                className="d-flex gap-2 justify-content-center flex-wrap mb-4 hero_zindex"
                data-aos="fade-down"
                data-aos-delay="550"
              >
                <button
                  className="btn btn-red px-4 py-2 fw-semibold"
                  style={{ fontSize: 13, borderRadius: 8 }}
                  onClick={() => navigate("/contact")}
                >
                  Get Free Consultation →
                </button>

                <button
                  className="btn btn-light bg-transparent text-white px-4 py-2 fw-semibold"
                  style={{ fontSize: 13, borderRadius: 8 }}
                  onClick={() => navigate("/our-course")}
                >
                  Explore Courses →
                </button>
              </div>

              <div className="d-flex gap-4 justify-content-center flex-wrap hero_zindex">
                {slider_1.map((s, i) => (
                  <div
                    key={s.label}
                    className="text-center"
                    data-aos="fade-down"
                    data-aos-delay={i * 200}
                  >
                    <div className="stat-num">{s.num}</div>
                    <div className="stat-label">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Slide 2 */}
          <div
            className="carousel-item"
            style={{
              backgroundImage: `url(${banner1})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              minHeight: "88vh",
            }}
          >
            <div className="d-flex flex-column justify-content-center align-items-center text-center p-4 p-md-5 h-100">
              <span
                className="hero-badge fw-semibold d-inline-block mb-3 py-2"
                data-aos="fade-down"
                data-aos-delay="100"
              >
                Evolve · Innovate · Succeed
              </span>

              <h1
                className="fw-semibold fs-1 text-white mb-3 hero_zindex"
                style={{ fontSize: "clamp(20px,4vw,28px)", lineHeight: 1.4 }}
                data-aos="fade-down"
                data-aos-delay="250"
              >
                Empowering Industries & Shaping Careers
                <br />
                <span style={{ color: PRIMARY }}>Through Innovation</span>
              </h1>

              <p
                className="hero-text mx-auto mb-4"
                style={{ fontSize: 15, maxWidth: 700, lineHeight: 1.8 }}
                data-aos="fade-down"
                data-aos-delay="400"
              >
                Skimitar Hindusthan delivers world-class industrial automation,
                IT solutions, and digital marketing services — while offering
                industry-aligned training programs for students, professionals,
                and businesses across India.
              </p>

              <div
                className="d-flex gap-2 justify-content-center flex-wrap mb-4 hero_zindex"
                data-aos="fade-down"
                data-aos-delay="550"
              >
                <button
                  className="btn btn-red px-4 py-2 fw-semibold"
                  style={{ fontSize: 13, borderRadius: 8 }}
                  onClick={() => navigate("/contact")}
                >
                  Get Free Consultation →
                </button>

                <button
                  className="btn btn-light bg-transparent text-white px-4 py-2 fw-semibold"
                  style={{ fontSize: 13, borderRadius: 8 }}
                  onClick={() => navigate("/corporatetrainings")}
                >
                  Browse Training Programs →
                </button>
              </div>

              <div className="d-flex flex-wrap justify-content-center gap-3 hero_zindex">
                {slider_2.map((s, i) => (
                  <div
                    key={s.label}
                    className="hero-pill text-white d-flex align-items-center px-3 py-2"
                    data-aos="fade-down"
                    data-aos-delay={i * 150}
                  >
                    <span className="fw-semibold me-2">{s.num}</span>
                    <span className="small">{s.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Controls */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleFade"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon">
            <i class="fa-solid fa-left-long"></i>
          </span>
        </button>

        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleFade"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon">
            <i class="fa-solid fa-right-long"></i>
          </span>
        </button>
      </div>

      {/* ── Ticker */}
      <div
        className="ticker-bar py-3 mb-5"
        data-aos="fade-down"
        data-aos-duration="600"
      >
        <Marquee speed={50} gradient={false}>
          {tickerItems.map((t, i) => (
            <span key={i} className="mx-4">
              {t}
            </span>
          ))}
        </Marquee>
      </div>

      {/* ── Problem & Solution */}
      <div className="container margin_top container_width">
        <div className="row justify-content-center align-items-stretch g-5">
          {/* Image Section */}
          <div className="col-sm-12 col-md-12 col-lg-6 mt-md-3 order-2 order-lg-1 d-flex flex-column justify-content-center">
            {/* Mobile View */}
            <div className="d-block d-md-none" data-aos="fade-up">
              <img
                className="img-fluid rounded-4 w-100 object-fit-cover"
                src={require("../assets/img/Home/intro-1.jpg")}
                alt="About 1"
              />
            </div>

            {/* Tablet View */}
            <div className="d-none d-md-block d-lg-none" data-aos="fade-up">
              <img
                className="img-fluid rounded-4 w-100 object-fit-cover"
                src={require("../assets/img/Home/intro-4.jpg")}
                alt="About 4"
              />
            </div>

            {/* Desktop View */}
            <div className="d-none d-lg-block">
              {/* Row 1 */}
              <div className="row g-3 justify-content-center">
                <div className="col-6" data-aos="fade-right" data-aos-delay="0">
                  <img
                    className="img-fluid rounded-4 w-100 h-100 object-fit-cover"
                    src={require("../assets/img/Home/intro-1.jpg")}
                    alt="About 1"
                  />
                </div>

                <div className="col-6">
                  <div className="row g-3 h-100">
                    <div
                      className="col-12"
                      data-aos="fade-right"
                      data-aos-delay="100"
                    >
                      <img
                        className="img-fluid rounded-4 w-100 h-100 object-fit-cover"
                        src={require("../assets/img/Home/intro-2.jpg")}
                        alt="About 2"
                      />
                    </div>

                    <div
                      className="col-12"
                      data-aos="fade-down"
                      data-aos-delay="200"
                    >
                      <img
                        className="img-fluid rounded-4 w-100 h-100 object-fit-cover"
                        src={require("../assets/img/Home/intro-3.jpg")}
                        alt="About 3"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div
            className="col-sm-12 col-md-12 col-lg-6 order-1 order-lg-2 d-flex flex-column justify-content-center"
            data-aos="fade-up"
          >
            <SectionLabel text="The Skimitar Advantage" />

            <h2 className="fw-semibold mb-3" style={{ fontSize: 20 }}>
              One Partner. Every Challenge. Every Stage.
            </h2>

            <p className="mb-3 content-text">
              <span className="fw-semibold">Skimitar Hindusthan Pvt Ltd</span>{" "}
              is a premier technology and engineering company operating across
              two powerful verticals industry services and professional
              training. We partner with businesses to deliver smart automation,
              embedded systems, software, and digital marketing solutions.
            </p>

            <p className="mb-3 content-text">
              Whether you're a business facing operational challenges or a
              professional seeking career growth Skimitar has the solution.
            </p>

            <div className="row">
              {problems.map((p, i) => (
                <div
                  className="col-12 col-md-6 col-lg-6"
                  key={p.title}
                  data-aos="fade-up"
                  data-aos-delay={i * 100}
                >
                  <div className="p-2 h-100">
                    <dt className="fw-bold mb-2" style={{ fontSize: 16 }}>
                      {p.title}
                    </dt>

                    <dl className="d-flex flex-column gap-2 mb-0">
                      {p.items.map((item) => (
                        <span
                          key={item}
                          className="d-flex align-items-start gap-2 ms-1 mb-0"
                          style={{ fontSize: 13 }}
                        >
                          <FaCheck
                            size={12}
                            style={{ color: p.color, marginTop: "2px" }}
                          />
                          {item}
                        </span>
                      ))}
                    </dl>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ── Services / Training Tabs */}
      <div className="bg_color py-5 margin_top">
        <div className="container container_width">
          <div data-aos="fade-up">
            <SectionLabel text="What We Offer" />
            <h2 className="fw-semibold mb-2" style={{ fontSize: 20 }}>
              Complete Solutions — Services & Training
            </h2>
            <p className="mb-3 content-text">
              Everything your business needs and everything your career demands
              — all under one roof.
            </p>
          </div>
          <div
            className="d-flex gap-2 mb-4"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <button
              className={`tab-pill${activeTab === "svc" ? " active" : ""}`}
              onClick={() => setActiveTab("svc")}
            >
              ⚙️ Industry Services
            </button>
            <button
              className={`tab-pill${activeTab === "trn" ? " active" : ""}`}
              onClick={() => setActiveTab("trn")}
            >
              🎓 Training Programs
            </button>
          </div>
          <div className="row g-3">
            {(activeTab === "svc" ? services : trainings).map((item, index) => (
              <div
                className={`col-12 col-md-6 col-lg-3 ${
                  index >= 2 ? "mt-md-3 mt-lg-3" : ""
                }`}
                key={item.name}
                data-aos="fade-up"
                data-aos-delay={index * 150}
              >
                <ServiceCard item={item} />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Who We Serve */}
      <div className="container margin_top container_width">
        <div className="row align-items-end g-5">
          {/* LEFT SIDE */}
          <div className="col-12 col-lg-6" data-aos="fade-right">
            <SectionLabel text="Who We Serve" />
            <h2 className="fw-semibold mb-4" style={{ fontSize: 20 }}>
              Built for Every Need — Business or Career
            </h2>

            <p className="mb-3 content-text">
              <span className="text-red fw-semibold">
                Skimitar Hindusthan Pvt Ltd
              </span>{" "}
              is a technology company providing embedded systems, IIoT
              solutions, software development, and digital marketing services.
              We support businesses, startups, SMEs, and enterprises with smart
              automation and scalable digital solutions.
            </p>

            <p className="mb-2 content-text">
              We also offer job-oriented training, internships, workshops, and
              corporate training programs designed to build real-world skills
              for students, graduates, and working professionals.
            </p>

            {/* IMAGES */}
            <div className="row justify-content-center g-3 mt-2">
              <div
                className="col-6 d-none d-lg-block"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <img
                  className="img-fluid rounded-4 w-100 h-100 object-fit-cover"
                  src={require("../assets/img/Home/project-4.jpg")}
                  alt="Achive 1"
                />
              </div>

              <div className="col-6" data-aos="zoom-in" data-aos-delay="200">
                <img
                  className="img-fluid rounded-4 w-100 h-100 object-fit-cover"
                  src={require("../assets/img/Home/project-6.jpg")}
                  alt="Achive 2"
                />
              </div>
            </div>
          </div>

          {/* RIGHT SIDE CARDS */}
          <div className="col-12 col-lg-6 mt-md-4">
            <div className="row g-3">
              {audiences.map((a, index) => (
                <div
                  className={`col-12 col-md-6 ${
                    index >= 2 ? "mt-md-3 mt-lg-3" : ""
                  }`}
                  key={a.title}
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <div className="card h-100 shadow border-0 rounded-4 text-center">
                    <div className="card-body p-4 d-flex flex-column align-items-center">
                      <div
                        className="d-flex justify-content-center align-items-center shadow rounded-circle mb-3"
                        style={{
                          width: "70px",
                          height: "70px",
                          background: "#f8f9fa",
                        }}
                      >
                        <img
                          src={a.icon}
                          alt={a.title}
                          style={{ width: "35px" }}
                        />
                      </div>

                      <p className="fw-semibold mb-2" style={{ fontSize: 16 }}>
                        {a.title}
                      </p>

                      <p className="mb-3 content-text">{a.desc}</p>

                      <div className="d-flex flex-wrap justify-content-center gap-1">
                        {a.tags.map((t) => (
                          <span
                            key={t}
                            className="badge rounded-pill"
                            style={{
                              background: a.bg,
                              color: a.tc,
                              fontSize: 11,
                            }}
                          >
                            {t}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ── Results */}
      <div className="bg_color py-5 margin_top">
        <div className="container container_width">
          <div className="row justify-content-center align-items-end g-5">
            {/* LEFT SECTION */}
            <div className="col-12 col-lg-5" data-aos="fade-right">
              <SectionLabel text="Our Impact" />

              <h2 className="fw-semibold mb-2" style={{ fontSize: 20 }}>
                Real Results. Real Growth.
              </h2>

              <p className="mb-3 content-text">
                Driving measurable business growth and empowering careers
                through automation, technology solutions, and industry-focused
                training programs.
              </p>

              <div
                className="d-block d-md-none d-lg-block"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <img
                  src={require("../assets/img/Home/impact-img.jpg")}
                  className="rounded-4 w-100"
                  style={{ height: "40%" }}
                  alt="Industrial automation and IT solutions impact by Skimitar Hindusthan"
                />
              </div>
            </div>

            {/* RIGHT SECTION */}
            <div className="col-12 col-lg-7">
              <div className="row g-4 align-items-stretch">
                {/* FIRST 4 CARDS */}
                {results.slice(0, 4).map((data, index) => (
                  <div
                    className="col-12 col-md-6 col-lg-4 d-flex"
                    key={index}
                    data-aos="zoom-in"
                    data-aos-delay={index * 200}
                  >
                    <div className="card shadow border-0 text-center w-100 h-100 d-flex">
                      <div className="card-body p-3 d-flex flex-column justify-content-center h-100">
                        <div
                          className="d-flex justify-content-center align-items-center shadow rounded-circle mx-auto mb-3"
                          style={{ width: "70px", height: "70px" }}
                        >
                          <img
                            src={data.image}
                            alt=""
                            style={{ width: "40px" }}
                          />
                        </div>

                        <div className="fw-semibold" style={{ fontSize: 22 }}>
                          {data.num}
                        </div>

                        <p className="small text-muted mb-0">{data.label}</p>
                      </div>
                    </div>
                  </div>
                ))}

                {/* CENTER LOGO */}
                <div
                  className="col-12 col-md-6 col-lg-4 d-none d-lg-flex"
                  data-aos="zoom-in"
                  data-aos-delay="320"
                >
                  <div className="card shadow border-0 w-100 h-100 d-flex justify-content-center align-items-center">
                    <img
                      src={require("../assets/img/SH Logo.png")}
                      alt="Company Logo"
                      className=" p-2"
                      style={{ width: "140px" }}
                    />
                  </div>
                </div>

                {/* LAST 4 CARDS */}
                {results.slice(4, 8).map((data, index) => (
                  <div
                    className="col-12 col-md-6 col-lg-4 d-flex"
                    key={index}
                    data-aos="zoom-in"
                    data-aos-delay={index * 80 + 400}
                  >
                    <div className="card shadow border-0 text-center w-100 h-100 d-flex">
                      <div className="card-body p-3 d-flex flex-column justify-content-center h-100">
                        <div
                          className="d-flex justify-content-center align-items-center shadow rounded-circle mx-auto mb-3"
                          style={{ width: "70px", height: "70px" }}
                        >
                          <img
                            src={data.image}
                            alt=""
                            style={{ width: "40px" }}
                          />
                        </div>

                        <div className="fw-semibold" style={{ fontSize: 22 }}>
                          {data.num}
                        </div>

                        <p className="small text-muted mb-0">{data.label}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Industries */}
      <div className="margin_top">
        <div className="container container_width">
          <div data-aos="fade-up">
            <SectionLabel text="Industries We Serve" />
            <h2 className="fw-semibold mb-4" style={{ fontSize: 20 }}>
              Trusted Across 20+ Industry Sectors
            </h2>
          </div>
        </div>

        <Slider
          dots={true}
          arrows={false}
          infinite={true}
          autoplay={true}
          autoplaySpeed={2500}
          speed={500}
          slidesToShow={3}
          slidesToScroll={1}
          centerMode={true}
          centerPadding="60px"
          focusOnSelect={true}
          responsive={[
            {
              breakpoint: 992,
              settings: { slidesToShow: 3, centerPadding: "30px" },
            },
            {
              breakpoint: 768,
              settings: { slidesToShow: 1, centerPadding: "80px" },
            },
            {
              breakpoint: 480,
              settings: { slidesToShow: 1, centerPadding: "40px" },
            },
          ]}
        >
          {industries.map((data, index) => {
            const [icon, ...titleParts] = data.split(" ");
            const title = titleParts.join(" ");
            return (
              <div key={index} className="px-2">
                <div
                  className="slick-industry-card text-center border bg-white rounded-3 shadow-sm position-relative overflow-hidden"
                  style={{
                    height: 130,
                    transition: "all 0.4s ease",
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = "#0d6efd";
                    e.currentTarget.style.boxShadow =
                      "0 12px 28px rgba(13,110,253,0.15)";
                    e.currentTarget.querySelector(
                      ".ind-stripe",
                    ).style.transform = "scaleX(1)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = "#dee2e6";
                    e.currentTarget.style.boxShadow = "";
                    e.currentTarget.querySelector(
                      ".ind-stripe",
                    ).style.transform = "scaleX(0)";
                  }}
                >
                  <div
                    className="ind-stripe position-absolute bottom-0 start-0 end-0"
                    style={{
                      height: 4,
                      background: "#0d6efd",
                      transform: "scaleX(0)",
                      transformOrigin: "left",
                      transition: "transform 0.3s ease",
                    }}
                  />
                  <div style={{ fontSize: 28 }}>{icon}</div>
                  <h6
                    className="fw-semibold mb-0 text-dark mt-2"
                    style={{ fontSize: 16 }}
                  >
                    {title}
                  </h6>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>

      {/* ── Brand Partners */}
      <div className="bg_color py-5 margin_top">
        <div className="container container_width">
          <div data-aos="fade-up">
            <SectionLabel text="Our Brand Partners" />
            <h2 className="fw-semibold mb-5" style={{ fontSize: 20 }}>
              Authorised Partner of Industry-Leading Brands
            </h2>
          </div>
          <div className="container my-5">
            <div className="row justify-content-center g-4">
              {partners.map((p, idx) => (
                <div
                  className={`col-6 col-md-4 col-lg-2 ${idx >= 3 ? "mt-md-4" : ""}`}
                  key={idx}
                  data-aos="fade-down"
                  data-aos-delay={idx * 300}
                >
                  <div className="partner-card text-center p-3 h-100">
                    <div className="partner-img-box mb-2">
                      <img
                        src={p.image}
                        alt={p.name}
                        className="img-fluid partner-img"
                      />
                    </div>

                    <p className="partner-name">{p.name}</p>
                    <p className="partner-type">{p.type}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ── Testimonials */}
      <div div className="container margin_top container_width">
        <div data-aos="fade-up">
          <SectionLabel text="Client & Student Reviews" />
          <h2 className="fw-semibold mb-4" style={{ fontSize: 20 }}>
            Real People. Real Results. Real Trust.
          </h2>
        </div>
        <div className="row g-4" data-aos="fade-up" data-aos-delay="100">
          <Slider {...testimonial_slider}>
            {testimonials.map((t, idx) => (
              <div key={idx} className="h-100 px-2">
                <div
                  className="card border-0 h-100"
                  style={{
                    borderRadius: "12px",
                    minHeight: "300px",
                  }}
                >
                  <div className="card-body d-flex flex-column">
                    {/* Stars */}
                    <div style={{ color: "#f4b400", fontSize: 14 }}>★★★★★</div>

                    {/* Quote */}
                    <p
                      className="fst-italic my-3 flex-grow-1"
                      style={{ fontSize: 13, lineHeight: 1.7 }}
                    >
                      "{t.quote}"
                    </p>

                    <hr className="my-2" />

                    {/* Author */}
                    <div className="d-flex align-items-center gap-3 mt-auto">
                      <img
                        src={t.avatar}
                        alt={t.author}
                        className="rounded-circle"
                        style={{
                          width: 50,
                          height: 50,
                          objectFit: "cover",
                          border: "2px solid #ccc",
                        }}
                      />

                      <div>
                        <p
                          className="fw-semibold mb-0"
                          style={{ fontSize: 13 }}
                        >
                          {t.author}
                        </p>

                        <p className="text-muted mb-1" style={{ fontSize: 11 }}>
                          {t.role}
                        </p>

                        <span
                          className="badge rounded-pill"
                          style={{
                            background: t.bg,
                            color: t.tc,
                            fontSize: 10,
                            padding: "2px 8px",
                          }}
                        >
                          {t.badge}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>

      {/* ── Lead Capture */}
      <div div className="bg_color py-5 margin_top">
        <div className="container container_width">
          <div data-aos="fade-up">
            <SectionLabel text="Get Started Today" />
            <h2 className="fw-semibold mb-2" style={{ fontSize: 20 }}>
              Talk to Our Experts — It's Free
            </h2>
            <p className="mb-4" style={{ fontSize: 15 }}>
              Whether you need a technology solution or a training program — get
              a free consultation with our domain experts today.
            </p>
          </div>
          <div className="row g-4 align-items-stretch">
            <div className="col-12 col-lg-7">
              <div className="row g-4">
                {leadPoints.map((lp, i) => (
                  <div
                    className="col-12"
                    key={lp.title}
                    data-aos="fade-right"
                    data-aos-delay={i * 100}
                  >
                    <div className="lead-point shadow d-flex gap-3 p-3 bg-light h-100 rounded">
                      <span style={{ fontSize: 20, flexShrink: 0 }}>
                        {lp.icon}
                      </span>

                      <div>
                        <p
                          className="fw-semibold mb-1"
                          style={{ fontSize: 13 }}
                        >
                          {lp.title}
                        </p>

                        <hr className="my-2" />

                        <p className="mb-0 text-muted" style={{ fontSize: 13 }}>
                          {lp.desc}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* RIGHT SECTION FORM */}
            <div
              className="col-12 col-lg-5"
              data-aos="fade-right"
              data-aos-delay="100"
            >
              <div
                className="card border shadow-sm h-100 p-4"
                style={{ borderRadius: 12, borderColor: "#e5e5e5" }}
              >
                <p
                  className="fw-semibold border-bottom pb-3 mb-3"
                  style={{ fontSize: 15 }}
                >
                  📋 Get a Free Consultation
                </p>

                {submitted ? (
                  <div className="text-center py-4">
                    <div style={{ fontSize: 40 }}>✅</div>

                    <p className="fw-semibold mt-3" style={{ fontSize: 15 }}>
                      Thank you, {form.name}!
                    </p>

                    <p className="text-muted" style={{ fontSize: 12 }}>
                      Our team will reach out within 24 hours.
                    </p>
                  </div>
                ) : (
                  <>
                    <div className="row">
                      <div className="col-6 mb-3">
                        <label
                          className="text-muted fw-semibold mb-1 d-block"
                          style={{ fontSize: 11 }}
                        >
                          Your Name *
                        </label>

                        <input
                          className="form-control"
                          type="text"
                          placeholder="Full name"
                          value={form.name}
                          onChange={(e) =>
                            setForm({ ...form, name: e.target.value })
                          }
                        />
                      </div>

                      <div className="col-6 mb-3">
                        <label
                          className="text-muted fw-semibold mb-1 d-block"
                          style={{ fontSize: 11 }}
                        >
                          Phone Number *
                        </label>

                        <input
                          className="form-control"
                          type="tel"
                          placeholder="+91 XXXXX XXXXX"
                          value={form.phone}
                          onChange={(e) =>
                            setForm({ ...form, phone: e.target.value })
                          }
                        />
                      </div>
                    </div>

                    <div className="mb-3">
                      <label
                        className="text-muted fw-semibold mb-1 d-block"
                        style={{ fontSize: 11 }}
                      >
                        E-mail ID *
                      </label>

                      <input
                        className="form-control"
                        type="mail"
                        placeholder="xyz@gmail.com"
                        value={form.email}
                        onChange={(e) =>
                          setForm({ ...form, email: e.target.value })
                        }
                      />
                    </div>

                    <div className="mb-3">
                      <label
                        className="text-muted fw-semibold mb-1 d-block"
                        style={{ fontSize: 11 }}
                      >
                        I'm Looking For
                      </label>

                      <select
                        className="form-select"
                        value={form.need}
                        onChange={(e) =>
                          setForm({ ...form, need: e.target.value })
                        }
                      >
                        <option value="">Select your need</option>
                        <option value="Industrial Automation Service">
                          Industrial Automation Service
                        </option>
                        <option value="IT / Software Solution">
                          IT / Software Solution
                        </option>
                        <option value="Digital Marketing Service">
                          Digital Marketing Service
                        </option>
                        <option value="Certification Course">
                          Certification Course
                        </option>
                        <option value="Internship / Project">
                          Internship / Project
                        </option>
                        <option value="Corporate Training">
                          Corporate Training
                        </option>
                        <option value="Seminar / Workshop">
                          Seminar / Workshop
                        </option>
                      </select>
                    </div>

                    <button
                      className="btn btn-red w-100 fw-semibold py-2 mt-3"
                      style={{ borderRadius: 8, fontSize: 13 }}
                      onClick={handleSubmit}
                    >
                      Request Free Consultation →
                    </button>

                    <p
                      className="text-muted text-center mt-2 mb-0"
                      style={{ fontSize: 10 }}
                    >
                      No commitment required · Free 30-minute expert call
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
